(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init(sectionEl) {
    if (sectionEl.dataset.swCfpHoverInit) return; // guard against double init
    sectionEl.dataset.swCfpHoverInit = '1';

    var observers = [];
    var ctx = gsap.context(function () {
      sectionEl.querySelectorAll('.sw-cfp__thumb').forEach(function (thumb) {
        var imgWrap = thumb.querySelector('.sw-cfp__thumb-img');
        if (!imgWrap) return;

        // Scale in on hover; stay scaled if active
        thumb.addEventListener('mouseenter', function () {
          gsap.killTweensOf(imgWrap);
          gsap.to(imgWrap, { scale: 1.5, duration: 0.4, ease: 'power2.out' });
        });

        // Scale out on mouse-leave only when not active
        thumb.addEventListener('mouseleave', function () {
          if (!thumb.classList.contains('is-active')) {
            gsap.killTweensOf(imgWrap);
            gsap.to(imgWrap, { scale: 1, duration: 0.35, ease: 'power2.inOut' });
          }
        });

        // Keep scale in sync with is-active class changes (switchTo calls)
        var wasActive = thumb.classList.contains('is-active');
        var mo = new MutationObserver(function () {
          var isActive = thumb.classList.contains('is-active');
          if (isActive === wasActive) return;
          wasActive = isActive;
          gsap.killTweensOf(imgWrap);
          if (isActive) {
            gsap.to(imgWrap, { scale: 1.5, duration: 0.4, ease: 'power2.out' });
          } else if (!thumb.matches(':hover')) {
            gsap.to(imgWrap, { scale: 1, duration: 0.35, ease: 'power2.inOut' });
          }
        });
        mo.observe(thumb, { attributes: true, attributeFilter: ['class'] });
        observers.push(mo);

        // Apply scale immediately if already active on init
        if (thumb.classList.contains('is-active')) {
          gsap.set(imgWrap, { scale: 1.5 });
        }
      });
    }, sectionEl);

    sectionEl._swCfpHoverTeardown = function () {
      ctx.revert();
      observers.forEach(function (mo) { mo.disconnect(); });
      observers = [];
      delete sectionEl.dataset.swCfpHoverInit;
    };

    document.addEventListener('shopify:section:unload', function onUnload(e) {
      if (!e.target.contains(sectionEl)) return;
      ctx.revert();
      observers.forEach(function (mo) { mo.disconnect(); });
      observers = [];
      delete sectionEl.dataset.swCfpHoverInit;
      document.removeEventListener('shopify:section:unload', onUnload);
    });
  }

  function initAll() {
    document.querySelectorAll('.shopify-section--sw-collection-featured-product').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.classList.contains('shopify-section--sw-collection-featured-product')) {
      swGsap.load(function () { init(e.target); });
    }
  });

  // SW: the section rebuilt its markup after crossing the phone/desktop breakpoint
  document.addEventListener('sw:cfp:reinit', function (e) {
    var sectionEl = e.target;
    if (sectionEl._swCfpHoverTeardown) sectionEl._swCfpHoverTeardown();
    swGsap.load(function () { init(sectionEl); });
  });

  // gsap core only: this script uses no ScrollTrigger
  swGsap.load(initAll);
})();
